import React from 'react';
import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';
import theme from '@mais-retorno-front/theme/theme';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { FaRegCheckCircle } from '@react-icons/all-files/fa/FaRegCheckCircle';

interface RedirectProDialogProps {
  open: boolean;
  onClose: () => void;
  redirectUrl?: string;
}

export const RedirectProDialog = ({
  open,
  onClose,
  redirectUrl = DEFAULT_ROUTES.retornoProAppSubscriptions,
}: RedirectProDialogProps) => {
  const onConfirm = () => {
    window.open(redirectUrl, '_blank');
    onClose();
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      onClose={() => onClose()}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '12px',
        },
      }}
    >
      <Box
        p={4}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          bgcolor=" #1DDD571A"
          width={80}
          height={80}
          borderRadius="50%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <FaRegCheckCircle color={theme.palette.secondary.main} size={40} />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          mt={4}
        >
          <Typography fontWeight={700} variant="h4" align="center">
            Aviso de redirecionamento
          </Typography>
          <Typography variant="body1" align="center" mt={2}>
            Você está sendo redirecionado para o gerenciamento de assinaturas do
            RetornoPRO. Se preferir permanecer no Prime, clique em "Cancelar".{' '}
          </Typography>
        </Box>

        <Box mt={3} display="flex" gap={3}>
          <Button variant="contained" color="inherit" onClick={() => onClose()}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => onConfirm()}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
